import React from 'react'

export default function Star() {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3460_17933)">
                <path d="M6.19987 9.30564L3.11387 10.9281L3.70337 7.49164L1.20337 5.05814L4.65337 4.55814L6.19637 1.43164L7.73937 4.55814L11.1894 5.05814L8.68937 7.49164L9.27887 10.9281L6.19987 9.30564Z" fill="#FFB900" stroke="#FFB900" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3460_17933">
                    <rect width="12" height="12" fill="white" transform="translate(0.199951 0.430664)" />
                </clipPath>
            </defs>
        </svg>

    )
}
